module.exports = "../images/fishing-lodge-07.jpg?v=4231d77";